import { Close } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import MuiDialogTitle from '@mui/material/DialogTitle'
import React from 'react'

import { capitalize } from '@hublo/utils/string'

import { Heading3 } from '../../../../data-display/typography/Typography'

import { useCustomDialogTitleStyles } from './CustomDialogTitle.styles'

export interface CustomDialogTitleProps {
  children: string
  onClose?: () => void
  noWrap?: boolean
  capitalizeTitle?: boolean
}

export const CustomDialogTitle = (props: CustomDialogTitleProps) => {
  const { classes } = useCustomDialogTitleStyles()
  const { children, onClose, noWrap, capitalizeTitle, ...other } = props

  return (
    <MuiDialogTitle {...other} className={classes.container}>
      <Heading3 noWrap={noWrap} component="span">
        {capitalizeTitle ? capitalize(children) : children}
      </Heading3>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          edge="end"
        >
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
}
